import { useState, type ReactNode } from 'react';

interface SafeCoverImgProps {
  /** URL de la cover. Si null/undefined ou 404, le fallback est rendu à la place. */
  readonly url: string | null | undefined;
  readonly alt?: string;
  readonly className?: string;
  /** Contenu de remplacement si l'image n'est pas chargeable. */
  readonly fallback: ReactNode;
}

/**
 * `<img>` tolérant aux 404 : utile pour les fallbacks OL Covers (`?default=false`)
 * qui renvoient 404 quand OL n'a pas la couverture. On bascule alors sur un
 * contenu stylé (titre + gradient) sans icône cassée.
 */
export function SafeCoverImg({
  url,
  alt = '',
  className,
  fallback,
}: SafeCoverImgProps): JSX.Element {
  const [failed, setFailed] = useState(false);
  if (!url || failed) {
    return <>{fallback}</>;
  }
  return (
    <img
      src={url}
      alt={alt}
      loading="lazy"
      onError={() => setFailed(true)}
      className={className}
    />
  );
}
